export const API_HOST =
    process.env.NODE_ENV === 'development' ? 'http://localhost:3020' : 'https://www.chernenko.digital/api';
